import {
  FileChartColumn as IconAnalytics,
  Folder as IconDocument,
  GitCompareArrows as IconMapping,
  Workflow as IconWorkflow,
} from "lucide-react";
import { ReactNode } from "react";

import { IModeOption, IModelOption, IPromptCategoryOption } from "../types";

export interface IQuickActionButton {
  labelKey: string;
  id: string;
  icon: ReactNode;
  promptKeys: string[];
}

export const QUICK_ACTION_BUTTONS: IQuickActionButton[] = [
  {
    labelKey: "quick_action_documents.label",
    id: "documents",
    icon: <IconDocument size={20} />,
    promptKeys: [
      "quick_action_documents.prompt_1",
      "quick_action_documents.prompt_2",
      "quick_action_documents.prompt_3",
      "quick_action_documents.prompt_4",
      "quick_action_documents.prompt_5",
    ],
  },
  {
    labelKey: "quick_action_mappings.label",
    id: "mappings",
    icon: <IconMapping size={20} />,
    promptKeys: [
      "quick_action_mappings.prompt_1",
      "quick_action_mappings.prompt_2",
      "quick_action_mappings.prompt_3",
      "quick_action_mappings.prompt_4",
      "quick_action_mappings.prompt_5",
    ],
  },
  {
    labelKey: "quick_action_workflows.label",
    id: "workflows",
    icon: <IconWorkflow size={20} />,
    promptKeys: [
      "quick_action_workflows.prompt_1",
      "quick_action_workflows.prompt_2",
      "quick_action_workflows.prompt_3",
      "quick_action_workflows.prompt_4",
      "quick_action_workflows.prompt_5",
    ],
  },
  {
    labelKey: "quick_action_analytics.label",
    id: "analytics",
    icon: <IconAnalytics size={20} />,
    promptKeys: [
      "quick_action_analytics.prompt_1",
      "quick_action_analytics.prompt_2",
      "quick_action_analytics.prompt_3",
      "quick_action_analytics.prompt_4",
      "quick_action_analytics.prompt_5",
    ],
  },
];

export const MAX_FILES = 15;
export const MAX_CHAR_LIMIT = 50000;
export const MAX_ATTACHMENTS = 15;
export const PANEL_WIDTH = 300;
export const BAR_COUNT = 24;
export const TYPE_INTERVAL_MS = 35;

export const MODEL_OPTIONS: IModelOption[] = [
  { id: "auto", nameKey: "model_auto", descKey: "model_auto_desc" },
  { id: "strong", nameKey: "model_strong", descKey: "model_strong_desc" },
  {
    id: "recommended",
    nameKey: "model_recommended",
    descKey: "model_recommended_desc",
  },
  { id: "minimal", nameKey: "model_minimal", descKey: "model_minimal_desc" },
];

export const MODE_OPTIONS: IModeOption[] = [
  { key: "fast", nameKey: "mode_fast_name", descKey: "mode_fast_desc" },
  {
    key: "think",
    nameKey: "mode_thinking_name",
    descKey: "mode_thinking_desc",
  },
];

export const CSV_LIKE_KINDS = ["csv", "excel", "xlsx"];
export const IMAGE_FILE_EXTENSIONS = [".png", ".jpg"];
export const EXCEL_FILE_EXTENSIONS = [".xlsx", ".xls"];
export const DOCUMENT_PREVIEW_UNSUPPORTED_MESSAGE =
  "Unable to preview this document format.";
export const DOCUMENT_PREVIEW_EXCEL_UNSUPPORTED_MESSAGE =
  "Raw Excel files cannot be previewed in the browser natively. Backend needs to return parsed data or convert it to PDF.";

export const PROMPT_CATEGORIES: IPromptCategoryOption[] = [
  { key: "all", labelKey: "all" },
  { key: "saved_by_you", labelKey: "saved_by_you" },
  ...QUICK_ACTION_BUTTONS.map((button) => ({
    key: button.id as IPromptCategoryOption["key"],
    labelKey: button.labelKey,
  })),
];

export const BAR_ANIMATION_DELAY_STEP_MS = 62;

export const USER_MESSAGE_COLLAPSE_LENGTH = 2000;

export const PIE_OR_DONUT_CHART_TYPES = ["donut", "pie", "radialBar"];

export const isPieOrDonutChart = (chartType: string): boolean => {
  return PIE_OR_DONUT_CHART_TYPES.includes(chartType);
};

export const TOOL_STATUS = {
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  DONE: "done",
  ERROR: "error",
} as const;

